// src/validation/VendorValidation.js
export const validateVendorForm = (data) => {
  let errors = {};

  if (!data.name) {
    errors.name = "Name is required";
  }

  if (!data.pendingamount || isNaN(data.pendingamount)) {
    errors.pendingamount = "Valid pending amount is required";
  }

  if (data.stores.length === 0) {
    errors.stores = "At least one store must be selected";
  }

  if (!data.address) {
    errors.address = "Address is required";
  }

  return errors;
};

export const validateselectedIdForm = (data) => {
  let errors;

  if (data.length === 0) {
    errors = "At least one store must be selected";
  }

  return errors;
};
